import { Table, Input, Button, Divider, Row, Col, DatePicker } from 'antd/lib';
import * as Icons from '@ant-design/icons';
import React from 'react';

class TablaDocumentos extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: this.props.documentos,
    };
  }

  render() {
    const columns = [
      {
        title: 'Usuario Carga',
        dataIndex: 'usuarioSubida',
        key: 'usuarioSubida',
      },
      {
        title: 'Tipo Documento',
        dataIndex: 'tipoDocumento',
        key: 'tipoDocumento',
      },
      {
        title: 'Titulo',
        dataIndex: 'titulo',
        key: 'titulo',
      },
      {
        title: 'Acciones',
        key: 'acciones',
        align: 'center',
        render: (text, record) => (
          <span>
            <Button
              type="primary"
              icon={<Icons.FilePdfOutlined />}
              onClick={() => this.props.getBase64(record.archivoId)}
              target={'_blank'}
            >
              Ver Documento
            </Button>
            <Divider type="vertical" />
            <Button
              type="danger"
              onClick={() => this.props.handleDelete(record._id)}
              disabled={
                !this.props.usuario ||
                (this.props.usuario.rol !== 'SUPERVISOR' &&
                  this.props.usuario.rol !== 'DGJP_DIRECTOR')
              }
            >
              Eliminar
            </Button>
          </span>
        ),
      },
    ];
    const { documentos } = this.props;
    // console.log('DOCUMENTOS: ', documentos);
    // console.log('PROPS: ', this.props);

    const paginationOptions = {
      onChange: page => {
        this.props.cambiarPagina(page);
      },
      total: this.props.total,
      current: this.props.pagina,
      pageSize: this.props.tamañoPagina ? this.props.tamañoPagina : 10,
      pageSizeOptions: ['2', '5', '10', '20', '50'],
      showSizeChanger: true,
      showQuickJumper: true,
      onShowSizeChange: (current, pageSize) => {
        this.props.cambiarTamañoPagina(pageSize);
        this.props.cambiarPagina(1);
      },
    };

    return (
      <Table
        rowKey="_id"
        columns={columns}
        pagination={paginationOptions}
        dataSource={documentos}
        bordered
        loading={this.props.loadingTabla}
        title={() => (
          <div>
            <h2 style={{ textAlign: 'center' }}>Documentos</h2>
          </div>
        )}
        locale={{ emptyText: 'Sin documentos' }}
      />
    );
  }
}

export default TablaDocumentos;
